export default __webpack_public_path__ + "static/media/before@3x.bdfb11c4.png";